export function PdfSubheading({ title, text }: { title: string; text: string | undefined }) {
  return (
    <h5 className='pdf-subheading'>
      <strong>{title}: </strong>
      <span>{text ?? '-'}</span>
    </h5>
  )
}
